import Index from './index.vue'
// import Create from './components/Create.vue'
import List from '@/modules/ReportCard/Terms/components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'terms',
    name: 'terms',
    component: Index,
    title: 'terms',
    redirect: { name: 'terms-list' },
    children: [
      {
        path: 'list',
        name: 'terms-list',
        component: List,
      },
      
    ],
  },
]
